var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('../layout/components/loaders');

var alarmsTablePagination = {};

alarmsTablePagination.oninit = function (vnode) {
  var ctrl = this;
  ctrl.url = vnode.attrs.url;
  ctrl.recordsToShow = vnode.attrs.recordsToShow;
  ctrl.originalData = JSON.parse(JSON.stringify(vnode.attrs.data));
  ctrl.location = vnode.attrs.location;
  ctrl.sortByLastActive = vnode.attrs.sortByLastActive;
  ctrl.sortByStatus = vnode.attrs.sortByStatus;
  ctrl.numberOfColumns = vnode.attrs.numberOfColumns || 10;
  ctrl.updateKey = vnode.attrs.updateKey;
  ctrl.refreshKey = vnode.attrs.refreshKey;
  ctrl.onRecordsUpdated = vnode.attrs.onRecordsUpdated;
  ctrl.onUserInteraction = vnode.attrs.onUserInteraction;

  ctrl.init = function(data){
    ctrl.data = data;
    ctrl.data.splice(1);
    ctrl.selectedPage = prop(1);
    ctrl.numberOfPages = prop(Math.ceil(ctrl.originalData.length / ctrl.numberOfColumns));
    
    var newViewArray = ctrl.originalData.slice(0,ctrl.numberOfColumns);
    ctrl.data.length = 0;
    ctrl.data.push(...newViewArray);
    ctrl.request(ctrl.data);
    m.redraw();
    
    ctrl.firstPage = function () {
      ctrl.selectedPage(1);
      ctrl.data.splice(0);
      ctrl.data.push(...ctrl.originalData.slice((ctrl.selectedPage()-1)*ctrl.numberOfColumns, (((ctrl.selectedPage()-1)*ctrl.numberOfColumns+(ctrl.numberOfColumns - 1))+1)));
      ctrl.request(ctrl.data);
    }  
    ctrl.previusPage = function () {
      ctrl.selectedPage(ctrl.selectedPage() - 1);
      ctrl.data.splice(0);
      ctrl.data.push(...ctrl.originalData.slice((ctrl.selectedPage()-1)*ctrl.numberOfColumns, (((ctrl.selectedPage()-1)*ctrl.numberOfColumns+(ctrl.numberOfColumns - 1))+1)));
      ctrl.request(ctrl.data);
    }
    ctrl.nextPage = function () {
      ctrl.selectedPage(ctrl.selectedPage() + 1);
      ctrl.data.splice(0);
      ctrl.data.push(...ctrl.originalData.slice((ctrl.selectedPage()-1)*ctrl.numberOfColumns, (((ctrl.selectedPage()-1)*ctrl.numberOfColumns+(ctrl.numberOfColumns - 1))+1)));
      ctrl.request(ctrl.data);
    }
    ctrl.lastPage = function () {
      ctrl.selectedPage(ctrl.numberOfPages());
      ctrl.data.splice(0);
      ctrl.data.push(...ctrl.originalData.slice((ctrl.selectedPage()-1)*ctrl.numberOfColumns, (((ctrl.selectedPage()-1)*ctrl.numberOfColumns+(ctrl.numberOfColumns - 1))+1)));
      ctrl.request(ctrl.data);
    }  
    ctrl.showPage = function (page) {
      ctrl.selectedPage(page);
      ctrl.data.splice(0);
      ctrl.data.push(...ctrl.originalData.slice((ctrl.selectedPage()-1)*ctrl.numberOfColumns, (((ctrl.selectedPage()-1)*ctrl.numberOfColumns+(ctrl.numberOfColumns - 1))+1)));
      ctrl.request(ctrl.data);
    }
  } 
  
  ctrl.request = function(rids){
    loaders.requestWithLoader({
      url: ctrl.url,
      body: {
        rids
      },
      method: 'POST',
      background: true
    })
    .then( data => {
      ctrl.recordsToShow(data)
      if(ctrl.recordsToShow().length < ctrl.numberOfColumns){
        let numberFakeRecords = ctrl.numberOfColumns - ctrl.recordsToShow().length;
        for (let index = 0; index < numberFakeRecords; index++) {
          ctrl.recordsToShow().push({})
        }
      }
      m.redraw();
      if (ctrl.onRecordsUpdated) {
        requestAnimationFrame(function () {
          ctrl.onRecordsUpdated();
        });
      }
    })
  }
  ctrl.init([...vnode.attrs.data]);
}

alarmsTablePagination.onupdate = function(vnode){
  var ctrl = this;
  ctrl.onRecordsUpdated = vnode.attrs.onRecordsUpdated;
  ctrl.onUserInteraction = vnode.attrs.onUserInteraction;
  var nextRefreshKey = vnode.attrs.refreshKey;
  if (ctrl.location['@rid'] != vnode.attrs.location['@rid'] || ctrl.sortByLastActive != vnode.attrs.sortByLastActive || ctrl.sortByStatus != vnode.attrs.sortByStatus) {
    ctrl.location = vnode.attrs.location;
    ctrl.sortByLastActive = vnode.attrs.sortByLastActive;
    ctrl.sortByStatus = vnode.attrs.sortByStatus;
    ctrl.originalData = JSON.parse(JSON.stringify(vnode.attrs.data));
    ctrl.init([...vnode.attrs.data]);
    ctrl.refreshKey = nextRefreshKey;
  }
  if (ctrl.originalData.length != vnode.attrs.data.length) {
    ctrl.originalData = JSON.parse(JSON.stringify(vnode.attrs.data));
    ctrl.init(vnode.attrs.data);
    ctrl.refreshKey = nextRefreshKey;
  }
  if (ctrl.updateKey !== vnode.attrs.updateKey) {
    ctrl.updateKey = vnode.attrs.updateKey;
    ctrl.originalData = JSON.parse(JSON.stringify(vnode.attrs.data));
    ctrl.init(vnode.attrs.data);
    ctrl.refreshKey = nextRefreshKey;
  }
  if (ctrl.refreshKey !== nextRefreshKey) {
    ctrl.refreshKey = nextRefreshKey;
    ctrl.originalData = JSON.parse(JSON.stringify(vnode.attrs.data));
    if (ctrl.selectedPage && typeof ctrl.selectedPage === 'function') {
      var start = (ctrl.selectedPage() - 1) * ctrl.numberOfColumns;
      var slice = ctrl.originalData.slice(start, start + ctrl.numberOfColumns);
      ctrl.data.splice(0);
      ctrl.data.push(...slice);
      ctrl.request(ctrl.data);
    } else {
      ctrl.init(vnode.attrs.data);
    }
  }
  window.onresize = m.redraw;
  
  
}

alarmsTablePagination.view = function(vnode) {
  var ctrl = this;
  let smallScreen = false;
  
  return m('div.w-100',{
    id: 'tab-alarms-container'+ctrl.originalData.length
  },[
    (()=>{
      if(document.getElementById('tab-alarms-container'+ctrl.originalData.length) && document.getElementById('tab-alarms-container'+ctrl.originalData.length).clientWidth < 720){
        smallScreen = true;
      }
      if(ctrl.numberOfPages()>1){
        return m('div.flex.flex-wrap',[
            function (){
              if(ctrl.numberOfPages()>1){
                return m('a.f4.ba.bw1.ph3.pv2.tc.v-btm.dib.pointer.mb1',
                {'data-alarm-control': 'true', onclick:function(e){
                  if (ctrl.onUserInteraction) ctrl.onUserInteraction();
                  if(ctrl.selectedPage()!=1){
                    ctrl.firstPage()
                  }
                }},
                [
                  m('span', {'aria-hidden':'true'}, '«'),
                ])
              }
            }(),
            m('a.f4.ba.bw1.ph3.pv2.tc.v-btm.dib.pointer.ml2.mb1',
              {'data-alarm-control': 'true', onclick:function(e){
                  if (ctrl.onUserInteraction) ctrl.onUserInteraction();
                  if(ctrl.selectedPage()!=1){
                    ctrl.previusPage()
                  }
                }},
                [
                  m('span', {'aria-hidden':'true'}, '<'),
                ]
            ),
            function (){
              var tabs=[]
              var list = function(page){
                return m('a.f4.ba.bw1.ph3.pv2.tc.v-btm.dib.pointer.ml2.mb1'+ (ctrl.selectedPage() == page ? ' bg-mid-gray' : ''),
                {'data-alarm-control': 'true', onclick: function(e){
                  if (ctrl.onUserInteraction) ctrl.onUserInteraction();
                  ctrl.showPage(page)
                }},
                [
                  m('span', {'aria-hidden':'true'}, page),
                ])
              }
              if(!smallScreen && ctrl.numberOfPages()<=7){
                for(var i=0; i<ctrl.numberOfPages();i++){
                  tabs.push(list(i+1))
                }
                return tabs
              }
              else if (!smallScreen){
                if(ctrl.selectedPage()<4){
                  for(var i=0; i<7;i++){
                    tabs.push(list(i+1))
                  } 
                  return tabs
                }
                if(ctrl.selectedPage()>3 && (ctrl.numberOfPages()-2)>ctrl.selectedPage()){
                  tabs.push(list(ctrl.selectedPage()-3))
                  tabs.push(list(ctrl.selectedPage()-2))
                  tabs.push(list(ctrl.selectedPage()-1))
                  tabs.push(list(ctrl.selectedPage()))
                  tabs.push(list(ctrl.selectedPage()+1))
                  tabs.push(list(ctrl.selectedPage()+2))
                  tabs.push(list(ctrl.selectedPage()+3))
                  return tabs
                }
                if((ctrl.numberOfPages()-3)<ctrl.selectedPage()){
                  for(var i=6; i>=0;i--){
                    tabs.push(list(ctrl.numberOfPages()-i))
                  } 
                  return tabs
                }
              }else{
                tabs.push(list(ctrl.selectedPage()))
                return tabs
              }
            }(),
            m('a.f4.ba.bw1.ph3.pv2.tc.v-btm.dib.pointer.ml2.mb1',
              {'data-alarm-control': 'true', onclick:function(e){
                  if (ctrl.onUserInteraction) ctrl.onUserInteraction();
                  if(ctrl.selectedPage()!=ctrl.numberOfPages()){
                    ctrl.nextPage();
                  }
              }
              },[
                m('span', {'aria-hidden':'true'}, '>'),
            ]),
            function (){
              if(ctrl.numberOfPages()>1){
                return m('a.f4.ba.bw1.ph3.pv2.tc.v-btm.dib.pointer.ml2.mb1',
                {'data-alarm-control': 'true', onclick:function(e){
                    if (ctrl.onUserInteraction) ctrl.onUserInteraction();
                    if(ctrl.selectedPage()!=ctrl.numberOfPages()){
                      ctrl.lastPage()
                }}
                },[
                  m('span', {'aria-hidden':'true'}, '» ' + ctrl.numberOfPages()),
                ])
              }
            }(),
        ])
      }else{
        return m('div')
      }
    })()
  ])
}

module.exports = alarmsTablePagination;
